export class ApiError extends Error {
  static {
    ApiError.prototype.name = "ApiError"
  }

  statusCode: number

  constructor(statusCode: number, message: string | string[], options?: ErrorOptions) {
    super(`error returned from api: statusCode: ${statusCode}, message: ${message}`, options)

    this.statusCode = statusCode
  }
}

export const isMaximumNumberOfGiftsReachedError = (error: unknown) => {
  return (
    error instanceof ApiError &&
    error.statusCode === 400 &&
    error.message ===
      "error returned from api: statusCode: 400, message: Reached maximum number of gifts."
  )
}

export class CreateUserError extends Error {
  static {
    CreateUserError.prototype.name = "CreateUserError"
  }

  code: string

  constructor(code: string, message: string, options?: ErrorOptions) {
    super(`failed to create user: code: ${code}, message: ${message}`, options)
    this.code = code
  }
}
